import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }              from '../api/api.service';
import { SessionService }          from '../sessions/session.service';
import { StripeSettingsComponent } from './stripe.settings.component';

export const StripeStates : Array<NgHybridStateDeclaration> = [
  {
    component: StripeSettingsComponent,
    name     : 'app.stripe-settings',
    url      : '/stripe-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) => apiService.get('/company_integrations'),
        token    : 'settings'
      }
    ]
  }
];
